import BillingsCargoTaxiBulkUpdateStatusRequest from "../../api/raily/billings/cargo-taxi/bulk-update-status/billings-cargo-taxi-bulk-update-status.request";
import billingsApiService from "../../api/raily/billings/billings-api.service";
import BillingsOrderAddressesRequest from "../../api/raily/billings/order/addresses/billings-order-addresses.request";
import BillingsOrderCargoRailyAddRequest from "../../api/raily/billings/order/cargo-raily/add/billings-order-cargo-raily-add.request";
import BillingsOrderRelatedTaxiDriverRequest from "../../api/raily/billings/order/related/taxi-driver/billings-order-related-taxi-driver.request";
import BillingsOrderRelatedTaxiTaxiRequest from "../../api/raily/billings/order/related/taxi-taxi/billings-order-related-taxi-taxi.request";
import BillingsPlanEntryRelatedCargoTaxiRequest from "../../api/raily/billings/plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi.request";
import BillingsPlanEntryRelatedTaxiTaxiRequest from "../../api/raily/billings/plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi.request";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import HttpError from "../../utils/http/http.error";
import BillingsOrderCargoTaxiCreateError from "./order/cargo-taxi/create/billings-order-cargo-taxi-create-error";
import BillingsOrderCargoTaxiCreateParams from "./order/cargo-taxi/create/billings-order-cargo-taxi-create-params";
import billingsOrderCargoTaxiCreateParamsFactory from "./order/cargo-taxi/create/billings-order-cargo-taxi-create-params.factory";
import BillingsCargoTaxiDetails from "./cargo-taxi/details/billings-cargo-taxi-details";
import BillingsCargoTaxiDetailsError from "./cargo-taxi/details/billings-cargo-taxi-details-error";
import BillingsCargoTaxiDetailsParams from "./cargo-taxi/details/billings-cargo-taxi-details-params";
import billingsCargoTaxiDetailsParamsFactory from "./cargo-taxi/details/billings-cargo-taxi-details-params.factory";
import billingsCargoTaxiDetailsFactory from "./cargo-taxi/details/billings-cargo-taxi-details.factory";
import BillingsOrderCargoTaxiDraft from "./order/cargo-taxi/draft/billings-order-cargo-taxi-draft";
import BillingsOrderCargoTaxiDraftError from "./order/cargo-taxi/draft/billings-order-cargo-taxi-draft-error";
import BillingsOrderCargoTaxiDraftParams from "./order/cargo-taxi/draft/billings-order-cargo-taxi-draft-params";
import billingsOrderCargoTaxiDraftParamsFactory from "./order/cargo-taxi/draft/billings-order-cargo-taxi-draft-params.factory";
import billingsOrderCargoTaxiDraftFactory from "./order/cargo-taxi/draft/billings-order-cargo-taxi-draft.factory";
import BillingsCargoTaxiUpdateStatusError from "./cargo-taxi/update-status/billings-cargo-taxi-update-status-error";
import BillingsCargoTaxiUpdateStatusParams from "./cargo-taxi/update-status/billings-cargo-taxi-update-status-params";
import billingsCargoTaxiUpdateStatusParamsFactory from "./cargo-taxi/update-status/billings-cargo-taxi-update-status-params.factory";
import BillingsCargoTaxiUpdateError from "./cargo-taxi/update/billings-cargo-taxi-update-error";
import BillingsCargoTaxiUpdateParams from "./cargo-taxi/update/billings-cargo-taxi-update-params";
import billingsCargoTaxiUpdateParamsFactory from "./cargo-taxi/update/billings-cargo-taxi-update-params.factory";
import BillingsCargoTaxiBulkUpdateStatusError from "./cargo-taxi/bulk-update-status/billings-cargo-taxi-bulk-update-status-error";
import BillingsCargoTaxiBulkUpdateStatusParams from "./cargo-taxi/bulk-update-status/billings-cargo-taxi-bulk-update-status-params";
import billingsCargoTaxiBulkUpdateStatusParamsFactory from "./cargo-taxi/bulk-update-status/billings-cargo-taxi-bulk-update-status-params.factory";
import BillingsOrderForwardRelatedCargoTaxi from "./order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi";
import BillingsOrderForwardRelatedCargoTaxiError from "./order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi-error";
import BillingsOrderForwardRelatedCargoTaxiParams from "./order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi-params";
import billingsOrderForwardRelatedCargoTaxiParamsFactory from "./order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi-params.factory";
import billingsOrderForwardRelatedCargoTaxiFactory from "./order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi.factory";
import BillingsOrderForwardRelatedTaxiDriver from "./order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver";
import BillingsOrderForwardRelatedTaxiDriverError from "./order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver-error";
import BillingsOrderForwardRelatedTaxiDriverParams from "./order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver-params";
import billingsOrderForwardRelatedTaxiDriverParamsFactory from "./order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver-params.factory";
import billingsOrderForwardRelatedTaxiDriverFactory from "./order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver.factory";
import BillingsOrderForwardRelatedTaxiTaxi from "./order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi";
import BillingsOrderForwardRelatedTaxiTaxiError from "./order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi-error";
import BillingsOrderForwardRelatedTaxiTaxiParams from "./order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi-params";
import billingsOrderForwardRelatedTaxiTaxiParamsFactory from "./order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi-params.factory";
import BillingsOrderAddressesError from "./order/addresses/billings-order-addresses-error";
import BillingsOrderAddressesParams from "./order/addresses/billings-order-addresses-params";
import billingsOrderAddressesParamsFactory from "./order/addresses/billings-order-addresses-params-factory";
import billingsOrderAddressesFactory from "./order/addresses/billings-order-addresses.factory";
import BillingsOrderCargoRailyAddError from "./order/cargo-raily/add/billings-order-cargo-raily-add-error";
import BillingsOrderCargoRailyAddParams from "./order/cargo-raily/add/billings-order-cargo-raily-add-params";
import billingsOrderCargoRailyAddParamsFactory from "./order/cargo-raily/add/billings-order-cargo-raily-add-params.factory";
import BillingsOrderCargoRailyDraft from "./order/cargo-raily/draft/billings-order-cargo-raily-draft";
import BillingsOrderCargoRailyDraftError from "./order/cargo-raily/draft/billings-order-cargo-raily-draft-error";
import BillingsOrderCargoRailyDraftParams from "./order/cargo-raily/draft/billings-order-cargo-raily-draft-params";
import billingsOrderCargoRailyDraftParamsFactory from "./order/cargo-raily/draft/billings-order-cargo-raily-draft-params.factory";
import billingsOrderCargoRailyDraftFactory from "./order/cargo-raily/draft/billings-order-cargo-raily-draft.factory";
import BillingsOrderCargoRailyRecalculate from "./order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate";
import BillingsOrderCargoRailyRecalculateError from "./order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate-error";
import BillingsOrderCargoRailyRecalculateParams from "./order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate-params";
import billingsOrderCargoRailyRecalculateParamsFactory from "./order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate-params.factory";
import billingsOrderCargoRailyRecalculateFactory from "./order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate.factory";
import BillingsOrderRelatedTaxiDriver from "./order/related/taxi-driver/billings-order-related-taxi-driver";
import BillingsOrderRelatedTaxiDriverError from "./order/related/taxi-driver/billings-order-related-taxi-driver-error";
import BillingsOrderRelatedTaxiDriverParams from "./order/related/taxi-driver/billings-order-related-taxi-driver-params";
import billingsOrderRelatedTaxiDriverParamsFactory from "./order/related/taxi-driver/billings-order-related-taxi-driver-params.factory";
import billingsOrderRelatedTaxiDriverFactory from "./order/related/taxi-driver/billings-order-related-taxi-driver.factory";
import BillingsOrderRelatedTaxiTaxi from "./order/related/taxi-taxi/billings-order-related-taxi-taxi";
import BillingsOrderRelatedTaxiTaxiError from "./order/related/taxi-taxi/billings-order-related-taxi-taxi-error";
import BillingsOrderRelatedTaxiTaxiParams from "./order/related/taxi-taxi/billings-order-related-taxi-taxi-params";
import billingsOrderRelatedTaxiTaxiParamsFactory from "./order/related/taxi-taxi/billings-order-related-taxi-taxi-params.factory";
import billingsOrderRelatedTaxiTaxiFactory from "./order/related/taxi-taxi/billings-order-related-taxi-taxi.factory";
import BillingsPlanEntryRelatedCargoTaxi from "./plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi";
import BillingsPlanEntryRelatedCargoTaxiError from "./plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi-error";
import BillingsPlanEntryRelatedCargoTaxiParams from "./plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi-params";
import billingsPlanEntryRelatedCargoTaxiParamsFactory from "./plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi-params.factory";
import billingsPlanEntryRelatedCargoTaxiFactory from "./plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi.factory";
import BillingsOrderRailyTaxiCreateError from "./order/raily-taxi/create/billings-order-raily-taxi-create-error";
import BillingsOrderRailyTaxiCreateParams from "./order/raily-taxi/create/billings-order-raily-taxi-create-params";
import billingsOrderRailyTaxiCreateParamsFactory from "./order/raily-taxi/create/billings-order-raily-taxi-create-params.factory";
import BillingsOrderRailyTaxiDraft from "./order/raily-taxi/draft/billings-order-raily-taxi-draft";
import BillingsOrderRailyTaxiDraftError from "./order/raily-taxi/draft/billings-order-raily-taxi-draft-error";
import BillingsOrderRailyTaxiDraftParams from "./order/raily-taxi/draft/billings-order-raily-taxi-draft-params";
import billingsOrderRailyTaxiDraftParamsFactory from "./order/raily-taxi/draft/billings-order-raily-taxi-draft-params.factory";
import billingsOrderRailyTaxiDraftFactory from "./order/raily-taxi/draft/billings-order-raily-taxi-draft.factory";
import BillingsOrderRailyTaxiRecalculate from "./order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate";
import BillingsOrderRailyTaxiRecalculateError from "./order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate-error";
import BillingsOrderRailyTaxiRecalculateParams from "./order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate-params";
import billingsOrderRailyTaxiRecalculateParamsFactory from "./order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate-params.factory";
import billingsOrderRailyTaxiRecalculateFactory from "./order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate.factory";
import BillingsOrderRelatedTaxiRailyParams from "./order/related/taxi-raily/billings-order-related-taxi-raily-params";
import BillingsOrderRelatedTaxiRailyItem from "./order/related/taxi-raily/billings-order-related-taxi-raily";
import billingsOrderRelatesTaxiRailyParamsFactory from "./order/related/taxi-raily/billings-order-related-taxi-raily-params.factory";
import billingsOrderRelatedTaxiRailyFactory from "./order/related/taxi-raily/billings-order-related-taxi-raily.factory";
import BillingsOrderRelatedTaxiRailyError from "./order/related/taxi-raily/billings-order-related-taxi-raily-error";
import BillingsOrderRelatedCargoRaily from "./order/related/cargo-raily/billings-order-related-cargo-raily";
import BillingsOrderRelatedCargoRailyError from "./order/related/cargo-raily/billings-order-related-cargo-raily-error";
import BillingsOrderRelatedCargoRailyParams from "./order/related/cargo-raily/billings-order-related-cargo-raily-params";
import billingsOrderRelatesCargoRailyParamsFactory from "./order/related/cargo-raily/billings-order-related-cargo-raily-params.factory";
import billingsOrderRelatedCargoRailyFactory from "./order/related/cargo-raily/billings-order-related-cargo-raily.factory";
import BillingsOrderRelatedRailyTaxiError from "./order/related/raily-taxi/billings-order-related-raily-taxi-error";
import BillingsOrderRelatedRailyTaxiParams from "./order/related/raily-taxi/billings-order-related-raily-taxi-params";
import BillingsOrderRelatedRailyTaxi from "./order/related/raily-taxi/billings-order-related-raily-taxi";
import billingsOrderRelatedRailyTaxiFactory from "./order/related/raily-taxi/billings-order-related-raily-taxi.factory";
import billingsOrderRelatedRailyTaxiParamsFactory from "./order/related/raily-taxi/billings-order-related-raily-taxi-params.factory";
import BillingsOrderForwardBillingsDownloadError from "./order-forward-billings/download/billings-order-forward-billings-download-error";
import BillingsOrderForwardBillingsDownloadParams from "./order-forward-billings/download/billings-order-forward-billings-download-params";
import BillingsOrderForwardBillingsDownload from "./order-forward-billings/download/billings-order-forward-billings-download";
import BillingsOrderForwardBillingsDownloadRequest from "../../api/raily/billings/order-forward-billings/download/billings-order-forward-billings-download.request";
import billingsOrderForwardBillingsDownloadParamsFactory from "./order-forward-billings/download/billings-order-forward-billings-download-params.factory";
import billingsOrderForwardBillingsDownloadFactory from "./order-forward-billings/download/billings-order-forward-billings-download.factory";
import BillingsOrderForwardBillingsListError from "./order-forward-billings/list/billings-order-forward-billings-list-error";
import BillingsOrderForwardBillingsListParams from "./order-forward-billings/list/billings-order-forward-billings-list-params";
import BillingsOrderForwardBillingsList from "./order-forward-billings/list/billings-order-forward-billings-list";
import billingsOrderForwardBillingsListParamsFactory from "./order-forward-billings/list/billings-order-forward-billings-list-params.factory";
import billingsOrderForwardBillingsListFactory from "./order-forward-billings/list/billings-order-forward-billings-list.factory";
import BillingsPlanEntryTaxiDriverAddParams from "./plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add-params";
import BillingsPlanEntryTaxiDriverAddError from "./plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add-error";
import BillingsPlanEntryTaxiDriverAddRequest from "../../api/raily/billings/plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add.request";
import billingsPlanEntryTaxiDriverAddParamsFactory from "./plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add-params.factory";
import BillingsPlanEntryTaxiDriverAdd from "./plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add";
import billingsPlanEntryTaxiDriverAddFactory from "./plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add.factory";
import BillingsPlanEntryTaxiDriverRecalculateError from "./plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate-error";
import BillingsPlanEntryTaxiDriverRecalculateParams from "./plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate-params";
import BillingsPlanEntryTaxiDriverRecalculate from "./plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate";
import billingsPlanEntryTaxiDriverRecalculateParamsFactory from "./plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate-params.factory";
import billingsPlanEntryTaxiDriverRecalculateFactory from "./plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate.factory";
import BillingsPlanEntryTaxiDriverDraftParams from "./plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft-params";
import BillingsPlanEntryTaxiDriverDraft from "./plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft";
import billingsPlanEntryTaxiDriverDraftParamsFactory from "./plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft-params.factory";
import billingsPlanEntryTaxiDriverDraftFactory from "./plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft.factory";
import BillingsPlanEntryTaxiDriverDraftError from "./plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft-error";
import BillingsTaxiTaxiDetailsError from "./taxi-taxi/details/billings-taxi-taxi-details-error";
import BillingsTaxiTaxiDetailsParams from "./taxi-taxi/details/billings-taxi-taxi-details-params";
import BillingsTaxiTaxiDetails from "./taxi-taxi/details/billings-taxi-taxi-details";
import billingsTaxiTaxiDetailsParamsFactory from "./taxi-taxi/details/billings-taxi-taxi-details-params.factory";
import billingsTaxiTaxiDetailsFactory from "./taxi-taxi/details/billings-taxi-taxi-details.factory";
import BillingsTaxiTaxiUpdateStatusError from "./taxi-taxi/update-status/billings-taxi-taxi-update-status-error";
import BillingsTaxiTaxiUpdateStatusParams from "./taxi-taxi/update-status/billings-taxi-taxi-update-status-params";
import billingsTaxiTaxiUpdateStatusParamsFactory from "./taxi-taxi/update-status/billings-taxi-taxi-update-status-params.factory";
import BillingsOrderForwardTaxiTaxiAddParams from "./order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add-params";
import BillingsOrderForwardTaxiTaxiAddError from "./order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add-error";
import BillingsOrderForwardTaxiTaxiAddRequest from "../../api/raily/billings/order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add.request";
import billingsOrderForwardTaxiTaxiAddParamsFactory from "./order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add-params.factory";
import billingsOrderForwardTaxiTaxiAddFactory from "./order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add.factory";
import BillingsOrderForwardTaxiTaxiAdd from "./order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add";
import BillingsOrderForwardTaxiTaxiDraftError from "./order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft-error";
import BillingsOrderForwardTaxiTaxiDraftParams from "./order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft-params";
import BillingsOrderForwardTaxiTaxiDraft from "./order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft";
import billingsOrderForwardDraftTaxiTaxiRequestFactory from "./order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft-params.factory";
import billingsOrderForwardTaxiTaxiDraftFactory from "./order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft.factory";
import BillingsOrderForwardRelatedCargoTaxiRequest from "../../api/raily/billings/order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi.request";
import BillingsOrderForwardRelatedTaxiDriverRequest from "../../api/raily/billings/order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver.request";
import BillingsOrderForwardRelatedTaxiTaxiRequest from "../../api/raily/billings/order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi.request";
import billingsOrderForwardRelatedTaxiTaxiFactory from "./order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi.factory";
import BillingsTaxiTaxiEditError from "./taxi-taxi/edit/billings-taxi-taxi-edit-params-error";
import BillingsTaxiTaxiEditParams from "./taxi-taxi/edit/billings-taxi-taxi-edit-params";
import billingsTaxiTaxiEditParamsFactory from "./taxi-taxi/edit/billings-taxi-taxi-edit-params.factory";
import BillingsTaxiDriverDetailsError from "./taxi-driver/details/billings-taxi-driver-details-error";
import BillingsTaxiDriverDetailsParams from "./taxi-driver/details/billings-taxi-driver-details-params";
import BillingsTaxiDriverDetails from "./taxi-driver/details/billings-taxi-driver-details";
import billingsTaxiDriverDetailsParamsFactory from "./taxi-driver/details/billings-taxi-driver-details-params.factory";
import billingsTaxiDriverDetailsFactory from "./taxi-driver/details/billings-taxi-driver-details.factory";
import BillingsTaxiDriverUpdateError from "./taxi-driver/update/billings-taxi-driver-update-error";
import BillingsTaxiDriverUpdateParams from "./taxi-driver/update/billings-taxi-driver-update-params";
import billingsTaxiDriverUpdateParamsFactory from "./taxi-driver/update/billings-taxi-driver-update-params.factory";
import billingsOrderTaxiRailyAddFactory from "./order/taxi-raily/add/billings-order-taxi-raily-add.factory";
import BillingsOrderTaxiRailyAddError from "./order/taxi-raily/add/billings-order-taxi-raily-add-error";
import billingsOrderTaxiRailyAddParamsFactory from "./order/taxi-raily/add/billings-order-taxi-raily-add-params.factory";
import BillingsOrderTaxiRailyAddRequest from "../../api/raily/billings/order/taxi-raily/add/billings-order-taxi-raily-add.request";
import BillingsOrderTaxiRailyAdd from "./order/taxi-raily/add/billings-order-taxi-raily-add";
import BillingsOrderTaxiRailyAddParams from "./order/taxi-raily/add/billings-order-taxi-raily-add-params";
import BillingsOrderTaxiRailyRecalculate from "./order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate";
import BillingsOrderTaxiRailyRecalculateError from "./order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate-error";
import BillingsOrderTaxiRailyRecalculateParams from "./order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate-params";
import billingsOrderTaxiRailyRecalculateRequestFactory from "./order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate-params.factory";
import billingsOrderTaxiRailyRecalculateFactory from "./order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate.factory";
import billingsOrderTaxiRailyDraftFactory from "./order/taxi-raily/draft/billings-order-taxi-raily-draft.factory";
import BillingsOrderTaxiRailyDraftError from "./order/taxi-raily/draft/billings-order-taxi-raily-draft-error";
import BillingsOrderTaxiRailyDraft from "./order/taxi-raily/draft/billings-order-taxi-raily-draft";
import BillingsOrderTaxiRailyDraftParams from "./order/taxi-raily/draft/billings-order-taxi-raily-draft-params";
import billingsOrderTaxiRailyDraftParamsFactory from "./order/taxi-raily/draft/billings-order-taxi-raily-draft-params.factory";
import BillingsOrderForwardTaxiTaxiRecalculate from "./order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate";
import BillingsOrderForwardTaxiTaxiRecalculateError from "./order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate-error";
import BillingsOrderForwardTaxiTaxiRecalculateParams from "./order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate-params";
import billingsOrderForwardTaxiTaxiRecalculateParamsFactory from "./order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate-params.factory";
import billingsOrderForwardTaxiTaxiRecalculateFactory from "./order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate.factory";
import BillingsOrderCargoTaxiRecalculate from "./order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate";
import BillingsOrderCargoTaxiRecalculateError from "./order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate-error";
import BillingsOrderCargoTaxiRecalculateParams from "./order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate-params";
import billingsOrderCargoTaxiRecalculateParamsFactory from "./order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate-params.factory";
import billingsOrderCargoTaxiRecalculateFactory from "./order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate.factory";
import BillingsPlanEntryRelatedTaxiTaxi from "./plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi";
import BillingsPlanEntryRelatedTaxiTaxiError from "./plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi-error";
import BillingsPlanEntryRelatedTaxiTaxiParams from "./plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi-params";
import billingsPlanEntryRelatedTaxiTaxiParamsFactory from "./plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi-params.factory";
import billingsPlanEntryRelatedTaxiTaxiFactory from "./plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";

const getOrderForwardRelatedCargoTaxiBillings = async (
  params: BillingsOrderForwardRelatedCargoTaxiParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderForwardRelatedCargoTaxi> => {
  const request: BillingsOrderForwardRelatedCargoTaxiRequest =
    billingsOrderForwardRelatedCargoTaxiParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().getOrderForwardRelatedCargoTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoTaxi =
      billingsOrderForwardRelatedCargoTaxiFactory.create(response);

    return cargoTaxi;
  } catch (_error) {
    const error = _error as
      | HttpError
      | BillingsOrderForwardRelatedCargoTaxiError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderForwardRelatedTaxiDriverBillings = async (
  params: BillingsOrderForwardRelatedTaxiDriverParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderForwardRelatedTaxiDriver> => {
  const request: BillingsOrderForwardRelatedTaxiDriverRequest =
    billingsOrderForwardRelatedTaxiDriverParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().getOrderForwardRelatedTaxiDriverBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiDriver =
      billingsOrderForwardRelatedTaxiDriverFactory.create(response);

    return taxiDriver;
  } catch (_error) {
    const error = _error as
      | HttpError
      | BillingsOrderForwardRelatedTaxiDriverError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderForwardRelatedTaxiTaxiBillings = async (
  params: BillingsOrderForwardRelatedTaxiTaxiParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderForwardRelatedTaxiTaxi> => {
  const request: BillingsOrderForwardRelatedTaxiTaxiRequest =
    billingsOrderForwardRelatedTaxiTaxiParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().getOrderForwardRelatedTaxiTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiTaxi =
      billingsOrderForwardRelatedTaxiTaxiFactory.create(response);

    return taxiTaxi;
  } catch (_error) {
    const error = _error as
      | HttpError
      | BillingsOrderForwardRelatedTaxiTaxiError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getPlanEntryRelatedCargoTaxiBillings = async (
  params: BillingsPlanEntryRelatedCargoTaxiParams,
  abortSignal: AbortSignal,
): Promise<BillingsPlanEntryRelatedCargoTaxi> => {
  const request: BillingsPlanEntryRelatedCargoTaxiRequest =
    billingsPlanEntryRelatedCargoTaxiParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().getPlanEntryRelatedCargoTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoTaxi = billingsPlanEntryRelatedCargoTaxiFactory.create(response);

    return cargoTaxi;
  } catch (_error) {
    const error = _error as HttpError | BillingsPlanEntryRelatedCargoTaxiError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getPlanEntryRelatedTaxiTaxiBillings = async (
  params: BillingsPlanEntryRelatedTaxiTaxiParams,
  abortSignal: AbortSignal,
): Promise<BillingsPlanEntryRelatedTaxiTaxi> => {
  const request: BillingsPlanEntryRelatedTaxiTaxiRequest =
    billingsPlanEntryRelatedTaxiTaxiParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().getPlanEntryRelatedTaxiTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiTaxi = billingsPlanEntryRelatedTaxiTaxiFactory.create(response);

    return taxiTaxi;
  } catch (_error) {
    const error = _error as HttpError | BillingsPlanEntryRelatedTaxiTaxiError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderRelatedTaxiDriverBillings = async (
  params: BillingsOrderRelatedTaxiDriverParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderRelatedTaxiDriver> => {
  const request: BillingsOrderRelatedTaxiDriverRequest =
    billingsOrderRelatedTaxiDriverParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().getOrderRelatedTaxiDriverBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiDriver = billingsOrderRelatedTaxiDriverFactory.create(response);

    return taxiDriver;
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderRelatedTaxiDriverError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderRelatedTaxiTaxiBillings = async (
  params: BillingsOrderRelatedTaxiTaxiParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderRelatedTaxiTaxi> => {
  const request: BillingsOrderRelatedTaxiTaxiRequest =
    billingsOrderRelatedTaxiTaxiParamsFactory.create(params);

  try {
    const response = await billingsApiService().getOrderRelatedTaxiTaxiBillings(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiTaxi = billingsOrderRelatedTaxiTaxiFactory.create(response);

    return taxiTaxi;
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderRelatedTaxiTaxiError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderBillingsAddresses = async (
  params: BillingsOrderAddressesParams,
  abortSignal: AbortSignal,
) => {
  const request: BillingsOrderAddressesRequest =
    billingsOrderAddressesParamsFactory.create(params);

  try {
    const response = await billingsApiService().getOrderBillingsAddresses(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const addresses = billingsOrderAddressesFactory.create(response);

    return addresses;
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderAddressesError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoTaxiBillingsDetails = async (
  params: BillingsCargoTaxiDetailsParams,
  abortSignal: AbortSignal,
): Promise<BillingsCargoTaxiDetails> => {
  const request = billingsCargoTaxiDetailsParamsFactory.create(params);

  try {
    const response = await billingsApiService().getCargoTaxiBillingsDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsCargoTaxiDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsCargoTaxiDetailsError;
    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateCargoTaxiBillings = async (
  params: BillingsCargoTaxiUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = billingsCargoTaxiUpdateParamsFactory.create(params);

  try {
    const response = await billingsApiService().updateCargoTaxiBillings(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsCargoTaxiUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateBulkStatusCargoTaxiBillings = async (
  params: BillingsCargoTaxiBulkUpdateStatusParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: BillingsCargoTaxiBulkUpdateStatusRequest =
    billingsCargoTaxiBulkUpdateStatusParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().updateBulkStatusCargoTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsCargoTaxiBulkUpdateStatusError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderCargoTaxiBillingsDraft = async (
  params: BillingsOrderCargoTaxiDraftParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderCargoTaxiDraft> => {
  const request = billingsOrderCargoTaxiDraftParamsFactory.create(params);

  try {
    const response = await billingsApiService().getOrderCargoTaxiBillingsDraft(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderCargoTaxiDraftFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderCargoTaxiDraftError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const recalculateOrderCargoTaxiBillings = async (
  params: BillingsOrderCargoTaxiRecalculateParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderCargoTaxiRecalculate> => {
  const request = billingsOrderCargoTaxiRecalculateParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().recalculateOrderCargoTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderCargoTaxiRecalculateFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderCargoTaxiRecalculateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createOrderCargoTaxiBillings = async (
  params: BillingsOrderCargoTaxiCreateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = billingsOrderCargoTaxiCreateParamsFactory.create(params);

  try {
    const response = await billingsApiService().createOrderCargoTaxiBillings(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderCargoTaxiCreateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateCargoTaxiBillingsStatus = async (
  params: BillingsCargoTaxiUpdateStatusParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request =
    billingsCargoTaxiUpdateStatusParamsFactory.createRequest(params);

  try {
    const response = await billingsApiService().updateCargoTaxiBillingsStatus(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsCargoTaxiUpdateStatusError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderRailyTaxiBillingsDraft = async (
  params: BillingsOrderRailyTaxiDraftParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderRailyTaxiDraft> => {
  const request =
    billingsOrderRailyTaxiDraftParamsFactory.createRequest(params);

  try {
    const response = await billingsApiService().getOrderRailyTaxiBillingsDraft(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderRailyTaxiDraftFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderRailyTaxiDraftError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const recalculateOrderRailyTaxiBillings = async (
  params: BillingsOrderRailyTaxiRecalculateParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderRailyTaxiRecalculate> => {
  const request =
    billingsOrderRailyTaxiRecalculateParamsFactory.createRequest(params);

  try {
    const response =
      await billingsApiService().recalculateOrderRailyTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderRailyTaxiRecalculateFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderRailyTaxiRecalculateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createOrderRailyTaxiBillings = async (
  params: BillingsOrderRailyTaxiCreateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request =
    billingsOrderRailyTaxiCreateParamsFactory.createRequest(params);

  try {
    const response = await billingsApiService().createOrderRailyTaxiBillings(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderRailyTaxiCreateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addOrderCargoRailyBillings = async (
  params: BillingsOrderCargoRailyAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: BillingsOrderCargoRailyAddRequest =
    billingsOrderCargoRailyAddParamsFactory.create(params);

  try {
    const response = await billingsApiService().addOrderCargoRailyBillings(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderCargoRailyAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const recalculateOrderCargoRailyBillings = async (
  params: BillingsOrderCargoRailyRecalculateParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderCargoRailyRecalculate> => {
  const request =
    billingsOrderCargoRailyRecalculateParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().recalculateOrderCargoRailyBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderCargoRailyRecalculateFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderCargoRailyRecalculateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderRelatedTaxiRailyBillings = async (
  params: BillingsOrderRelatedTaxiRailyParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderRelatedTaxiRailyItem[]> => {
  const request =
    billingsOrderRelatesTaxiRailyParamsFactory.createRequest(params);

  try {
    const response =
      await billingsApiService().getOrderRelatedTaxiRailyBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderRelatedTaxiRailyFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderRelatedTaxiRailyError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderRelatedCargoRailyBillings = async (
  params: BillingsOrderRelatedCargoRailyParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderRelatedCargoRaily[]> => {
  const request =
    billingsOrderRelatesCargoRailyParamsFactory.createRequest(params);

  try {
    const response =
      await billingsApiService().getOrderRelatedCargoRailyBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderRelatedCargoRailyFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderRelatedCargoRailyError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderCargoRailyBillingsDraft = async (
  params: BillingsOrderCargoRailyDraftParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderCargoRailyDraft> => {
  const request = billingsOrderCargoRailyDraftParamsFactory.create(params);

  try {
    const response = await billingsApiService().getOrderCargoRailyBillingsDraft(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
      ``;
    }

    return billingsOrderCargoRailyDraftFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderCargoRailyDraftError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderRelatedRailyTaxiBillings = async (
  params: BillingsOrderRelatedRailyTaxiParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderRelatedRailyTaxi[]> => {
  const request =
    billingsOrderRelatedRailyTaxiParamsFactory.createRequest(params);

  try {
    const response =
      await billingsApiService().getOrderRelatedRailyTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderRelatedRailyTaxiFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderRelatedRailyTaxiError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderForwardBillingsDownload = async (
  params: BillingsOrderForwardBillingsDownloadParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderForwardBillingsDownload> => {
  const request: BillingsOrderForwardBillingsDownloadRequest =
    billingsOrderForwardBillingsDownloadParamsFactory.create(params);

  try {
    const response = await billingsApiService().getOrderForwardBillingsDownload(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderForwardBillingsDownloadFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | BillingsOrderForwardBillingsDownloadError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addPlanEntryTaxiDriverBillings = async (
  params: BillingsPlanEntryTaxiDriverAddParams,
  abortSignal: AbortSignal,
): Promise<BillingsPlanEntryTaxiDriverAdd> => {
  const request: BillingsPlanEntryTaxiDriverAddRequest =
    billingsPlanEntryTaxiDriverAddParamsFactory.create(params);

  try {
    const response = await billingsApiService().addPlanEntryTaxiDriverBillings(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return billingsPlanEntryTaxiDriverAddFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsPlanEntryTaxiDriverAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addOrderForwardTaxiTaxiBillings = async (
  params: BillingsOrderForwardTaxiTaxiAddParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderForwardTaxiTaxiAdd> => {
  const request: BillingsOrderForwardTaxiTaxiAddRequest =
    billingsOrderForwardTaxiTaxiAddParamsFactory.create(params);

  try {
    const response = await billingsApiService().addOrderForwardTaxiTaxiBillings(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderForwardTaxiTaxiAddFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderForwardTaxiTaxiAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderForwardBillingsList = async (
  params: BillingsOrderForwardBillingsListParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderForwardBillingsList> => {
  const request = billingsOrderForwardBillingsListParamsFactory.create(params);

  try {
    const response = await billingsApiService().getOrderForwardBillingsList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return billingsOrderForwardBillingsListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderForwardBillingsListError;
    throw handleErrorFactory.handleCustomError(error);
  }
};

const recalculatePlanEntryTaxiDriverBillings = async (
  params: BillingsPlanEntryTaxiDriverRecalculateParams,
  abortSignal: AbortSignal,
): Promise<BillingsPlanEntryTaxiDriverRecalculate> => {
  const request =
    billingsPlanEntryTaxiDriverRecalculateParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().recalculatePlanEntryTaxiDriverBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return billingsPlanEntryTaxiDriverRecalculateFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | BillingsPlanEntryTaxiDriverRecalculateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getPlanEntryTaxiDriverBillingsDraft = async (
  params: BillingsPlanEntryTaxiDriverDraftParams,
  abortSignal: AbortSignal,
): Promise<BillingsPlanEntryTaxiDriverDraft> => {
  const request = billingsPlanEntryTaxiDriverDraftParamsFactory.create(params);

  try {
    const response =
      await billingsApiService().getPlanEntryTaxiDriverBillingsDraft(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return billingsPlanEntryTaxiDriverDraftFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsPlanEntryTaxiDriverDraftError;
    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiTaxiBillingsDetails = async (
  params: BillingsTaxiTaxiDetailsParams,
  abortSignal: AbortSignal,
): Promise<BillingsTaxiTaxiDetails> => {
  const request = billingsTaxiTaxiDetailsParamsFactory.createRequest(params);

  try {
    const response = await billingsApiService().getTaxiTaxiBillingsDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsTaxiTaxiDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsTaxiTaxiDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateTaxiTaxiStatusBillings = async (
  params: BillingsTaxiTaxiUpdateStatusParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = billingsTaxiTaxiUpdateStatusParamsFactory.create(params);

  try {
    const response = await billingsApiService().updateTaxiTaxiStatusBillings(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsTaxiTaxiUpdateStatusError;

    throw handleErrorFactory.handleCustomError(error);
  }
};
const getOrderForwardTaxiTaxiBillingsDraft = async (
  params: BillingsOrderForwardTaxiTaxiDraftParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderForwardTaxiTaxiDraft> => {
  const request =
    billingsOrderForwardDraftTaxiTaxiRequestFactory.create(params);

  try {
    const response =
      await billingsApiService().getOrderForwardTaxiTaxiBillingsDraft(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderForwardTaxiTaxiDraftFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderForwardTaxiTaxiDraftError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const recalculateOrderForwardTaxiTaxiBillings = async (
  params: BillingsOrderForwardTaxiTaxiRecalculateParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderForwardTaxiTaxiRecalculate> => {
  const request =
    billingsOrderForwardTaxiTaxiRecalculateParamsFactory.createRequest(params);

  try {
    const response =
      await billingsApiService().recalculateOrderForwardTaxiTaxiBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return billingsOrderForwardTaxiTaxiRecalculateFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | BillingsOrderForwardTaxiTaxiRecalculateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addOrderTaxiRailyBillings = async (
  params: BillingsOrderTaxiRailyAddParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderTaxiRailyAdd> => {
  const request: BillingsOrderTaxiRailyAddRequest =
    billingsOrderTaxiRailyAddParamsFactory.create(params);

  try {
    const response = await billingsApiService().addOrderTaxiRailyBillings(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderTaxiRailyAddFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderTaxiRailyAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const recalculateOrderTaxiRailyBillings = async (
  params: BillingsOrderTaxiRailyRecalculateParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderTaxiRailyRecalculate> => {
  const request =
    billingsOrderTaxiRailyRecalculateRequestFactory.create(params);

  try {
    const response =
      await billingsApiService().recalculateOrderTaxiRailyBillings(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderTaxiRailyRecalculateFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderTaxiRailyRecalculateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const editTaxiTaxiBillings = async (
  params: BillingsTaxiTaxiEditParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = billingsTaxiTaxiEditParamsFactory.createRequest(params);

  try {
    const response = await billingsApiService().editTaxiTaxiBillings(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsTaxiTaxiEditError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiDriverBillingsDetails = async (
  params: BillingsTaxiDriverDetailsParams,
  abortSignal: AbortSignal,
): Promise<BillingsTaxiDriverDetails> => {
  const request = billingsTaxiDriverDetailsParamsFactory.createRequest(params);

  try {
    const response = await billingsApiService().getTaxiDriverBillingsDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return billingsTaxiDriverDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsTaxiDriverDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateTaxiDriverBillings = async (
  params: BillingsTaxiDriverUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = billingsTaxiDriverUpdateParamsFactory.createRequest(params);

  try {
    const response = await billingsApiService().updateTaxiDriverBillings(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | BillingsTaxiDriverUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderTaxiRailyBillingsDraft = async (
  params: BillingsOrderTaxiRailyDraftParams,
  abortSignal: AbortSignal,
): Promise<BillingsOrderTaxiRailyDraft> => {
  const request = billingsOrderTaxiRailyDraftParamsFactory.create(params);

  try {
    const response = await billingsApiService().getOrderTaxiRailyBillingsDraft(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return billingsOrderTaxiRailyDraftFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | BillingsOrderTaxiRailyDraftError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const billingService = {
  getOrderForwardRelatedCargoTaxiBillings,
  getOrderForwardRelatedTaxiDriverBillings,
  getOrderForwardRelatedTaxiTaxiBillings,
  getPlanEntryRelatedCargoTaxiBillings,
  getPlanEntryRelatedTaxiTaxiBillings,
  getOrderRelatedTaxiDriverBillings,
  getOrderRelatedTaxiTaxiBillings,
  getOrderBillingsAddresses,
  getCargoTaxiBillingsDetails,
  updateCargoTaxiBillings,
  getOrderCargoTaxiBillingsDraft,
  recalculateOrderCargoTaxiBillings,
  createOrderCargoTaxiBillings,
  updateCargoTaxiBillingsStatus,
  getOrderRailyTaxiBillingsDraft,
  recalculateOrderRailyTaxiBillings,
  createOrderRailyTaxiBillings,
  updateBulkStatusCargoTaxiBillings,
  getOrderRelatedTaxiRailyBillings,
  getOrderRelatedCargoRailyBillings,
  addOrderCargoRailyBillings,
  recalculateOrderCargoRailyBillings,
  getOrderCargoRailyBillingsDraft,
  getOrderRelatedRailyTaxiBillings,
  getOrderForwardBillingsDownload,
  getOrderForwardBillingsList,
  addPlanEntryTaxiDriverBillings,
  recalculatePlanEntryTaxiDriverBillings,
  getPlanEntryTaxiDriverBillingsDraft,
  getTaxiTaxiBillingsDetails,
  updateTaxiTaxiStatusBillings,
  addOrderForwardTaxiTaxiBillings,
  getOrderForwardTaxiTaxiBillingsDraft,
  recalculateOrderForwardTaxiTaxiBillings,
  editTaxiTaxiBillings,
  getTaxiDriverBillingsDetails,
  updateTaxiDriverBillings,
  addOrderTaxiRailyBillings,
  recalculateOrderTaxiRailyBillings,
  getOrderTaxiRailyBillingsDraft,
};

export default billingService;
